import { Input } from 'antd'
import React, { Component } from 'react'
import './favorecido.css'


export default class Favorecido extends Component {
    render() {
        console.log(this.props.favorecido)
        return (
            <>
                <div className="w-100 mb-4 mt-4 d-flex flex-wrap">
                    {this.props.favorecido.type === 'ELETRONIC_BANK_CASHOUT' &&
                    <div className="divInputFavorecido">
                        <label className="favorecido">Tipo de conta</label> 
                        <Input type='text' className='inputTransferir' disabled='true' value={`${this.props.favorecido.accountType === 'CHECKING_ACCOUNT' ? 'Conta Corrente' : 'Conta Poupança'} `}></Input>
                    </div> }
                    <div className="divInputFavorecido">
                        <label className="favorecido">{this.props.favorecido.documentType}</label> 
                        <Input type='text' className='inputTransferir' disabled='true' value={`${this.props.favorecido.document}`}></Input>
                    </div>
                    <div className="divInputFavorecido">
                        <label className="favorecido">Nome</label> 
                        <Input type='text' className='inputTransferir' disabled='true' value={`${this.props.favorecido.name}`}></Input>
                    </div>
                </div>
                {this.props.favorecido.type === 'ELETRONIC_BANK_CASHOUT' &&
                <>
                <hr className='linhaHorizontalFavorecido'/>
                <div className="w-100 mt-4 d-flex flex-wrap">
                    <div className="divInputFavorecido">
                        <label className="favorecido">Nome do banco</label> 
                        <Input type='text' className='inputTransferir' disabled='true' value={`${this.props.favorecido.bankName}`}></Input>
                    </div>
                    <div className="divInputFavorecido">
                        <label className="favorecido">Agência</label> 
                        <Input type='text' className='inputTransferir' disabled='true' value={`${this.props.favorecido.branch}`}></Input>
                    </div>
                    <div className="divInputFavorecido">
                        <label className="favorecido">Conta</label> 
                        <Input type='text' className='inputTransferir' disabled='true' value={`${this.props.favorecido.account}-${this.props.favorecido.accountDigit}`}></Input>
                    </div>
                </div>
                </> }
            </>
        )
    }
}